import { apiClient } from "@/shared/api/client";

export interface ActualResultDto {
    totalAchievers: number;
    totalPayout: number;
    periodAchievers: number;
    periodPayout: number;
}

export interface MissionDto {
    seqNo: number;
    suppId: string;
    title: string;
    missionType: string;
    periodType: string;
    targetCnt: number;
    rewardAmt: number;
    maxCnt: number;
    startDate: string;
    endDate: string;
    description: string;
    targetType: string;
    targetRiders: string[];
    statusCode: string;
    insDate: string | null;
    insUser: string | null;
    updDate: string | null;
    updUser: string | null;
    actualResult?: ActualResultDto;
}

export interface GetMissionListResponse {
    totalCount: number;
    missions: MissionDto[];
}

export interface RegisterMissionRequest {
    suppId: string;
    title: string;
    missionType: string;
    periodType: string;
    targetCnt: number;
    rewardAmt: number;
    maxCnt: number;
    startDate: string;
    endDate: string;
    description: string;
    targetType: string;
    targetRiders: string[];
    insUser: string;
}

export interface UpdateMissionRequest {
    title: string;
    missionType: string;
    periodType: string;
    targetCnt: number;
    rewardAmt: number;
    maxCnt: number;
    startDate: string;
    endDate: string;
    description: string;
    targetType: string;
    targetRiders: string[];
    updUser: string;
}

export interface MissionActionResponse {
    success: boolean;
    message: string;
    seqNo: number | null;
}

export interface DailyDetailDto {
    date: string;         // yyyyMMdd
    deliveryCount: number;
    achieved: boolean;    // DAILY 미션: 해당 날 달성 여부
    payoutAmount: number; // DAILY 미션: 해당 날 계산 지급액
}

export interface PeriodDetailDto {
    startDate: string;    // 주정산 시작일 yyyyMMdd
    endDate: string;      // 주정산 종료일 yyyyMMdd
    deliveryCount: number; // 주정산 기간 전체 배달건수
    achieved: boolean;
    payoutAmount: number;
    dailyDetails: DailyDetailDto[];
}

export interface RiderResultDto {
    riderId: string;
    payoutAmount: number;
    periodDetails: PeriodDetailDto[];
}

export interface GetMissionRiderResultsResponse {
    missionSeqNo: number;
    settled: boolean;
    riderResults: RiderResultDto[];
}

const BASE_PATH = '/api/v1/promotion/mission';

export const promoMissionApi = {
    getMissionList: async (suppId?: string): Promise<GetMissionListResponse> => {
        const response = await apiClient.get<GetMissionListResponse>(
            `${BASE_PATH}/list`,
            { params: suppId ? { suppId } : undefined }
        );
        return response.data;
    },

    registerMission: async (request: RegisterMissionRequest): Promise<MissionActionResponse> => {
        const response = await apiClient.post<MissionActionResponse>(
            `${BASE_PATH}/register`,
            request
        );
        return response.data;
    },

    updateMission: async (seqNo: number, request: UpdateMissionRequest): Promise<MissionActionResponse> => {
        const response = await apiClient.put<MissionActionResponse>(
            `${BASE_PATH}/${seqNo}`,
            request
        );
        return response.data;
    },

    deleteMission: async (seqNo: number): Promise<MissionActionResponse> => {
        const response = await apiClient.delete<MissionActionResponse>(
            `${BASE_PATH}/${seqNo}`
        );
        return response.data;
    },

    updateMissionStatus: async (seqNo: number, statusCode: string, updUser: string): Promise<MissionActionResponse> => {
        const response = await apiClient.patch<MissionActionResponse>(
            `${BASE_PATH}/${seqNo}/status`,
            { statusCode, updUser }
        );
        return response.data;
    },

    getMissionRiderResults: async (seqNo: number): Promise<GetMissionRiderResultsResponse> => {
        const response = await apiClient.get<GetMissionRiderResultsResponse>(
            `${BASE_PATH}/${seqNo}/rider-results`
        );
        return response.data;
    },
};
